"use client";

import { useEffect } from "react";
import { useSiteConfig } from "@/lib/SiteConfigContext";

// Applies the CMS-chosen accent color by overriding the `--gold` CSS variable
// on <html>. The dark/light accent shades derive from `--gold` in globals.css,
// so this single override recolors every accent. The primary (navy) color is
// static (locked to the logo) and is never touched here.
export default function ThemeColor() {
  const { secondaryColor } = useSiteConfig();
  useEffect(() => {
    if (secondaryColor) {
      document.documentElement.style.setProperty("--gold", secondaryColor);
    }
  }, [secondaryColor]);
  return null;
}
